export default "__VITE_ASSET__DYQ9GyUs__"